<template>
  <div>
    <div v-if="dialogVisible">
      <el-form :model="data" :rules="rules" size="mini"  ref="ruleForm" label-width="100px" :inline="true" class="demo-form-inline">
        <el-form-item label="编号" prop="code">
          <el-input v-model="data.code" maxlength="50" clearable placeholder="请输入编号" style="width: 180px;"></el-input>
        </el-form-item>
        <el-form-item label="功能名称" prop="name">
          <el-input v-model="data.name" maxlength="50" clearable placeholder="请输入功能名称" style="width: 180px;"></el-input>
        </el-form-item>
        <el-form-item label="排序号" prop="sort">
          <el-input v-model="data.sort" maxlength="50" clearable placeholder="请输入排序号" style="width: 180px;"></el-input>
        </el-form-item>
        <el-form-item label="功能类型" prop="type">
          <el-select v-model="data.type" placeholder="请选择功能类型" style="width: 180px;">
            <el-option label="菜单" value="1"></el-option>
            <el-option label="组件库" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="icon图标" prop="iconClass" v-if="data.type === '1'">
          <el-select v-model="data.iconClass" placeholder="请选择icon图标" style="width: 180px;">
            <!-- <el-option label="el-icon-location" value="el-icon-location"><i class="el-icon-location"></i></el-option>
            <el-option label="el-icon-setting" value="el-icon-setting"><i class="el-icon-setting"></i></el-option>
            <el-option label="el-icon-menu" value="el-icon-menu"><i class="el-icon-menu"></i></el-option>
            <el-option label="el-icon-document" value="el-icon-document"><i class="el-icon-document"></i></el-option> -->
            <el-option v-for="(item, index) in iconList" :key="index" :label="item.valueClass" :value="item.valueClass">
              <!-- <i :class="item.valueClass"></i> -->
              <svg class="myIconStyle" aria-hidden="true">
                <use :xlink:href="'#' + item.valueClass"></use>
              </svg>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="菜单地址" prop="path" v-if="data.type === '1'">
          <el-input v-model="data.path" clearable maxlength="50" placeholder="请输入菜单地址" style="width: 180px;"></el-input>
        </el-form-item>
        <el-form-item label="路由地址" v-if="data.type === '1'">
          <el-input v-model="data.routerPath" clearable maxlength="50" placeholder="请输入组件地址" style="width: 180px;"></el-input>
        </el-form-item>
        <el-form-item label="组件地址" v-if="data.type === '1'">
          <el-input v-model="data.component" clearable maxlength="50" placeholder="请输入组件地址" style="width: 180px;"></el-input>
        </el-form-item>
        <el-form-item label="组件名" v-if="data.type === '1'">
          <el-input v-model="data.componentName" clearable maxlength="50" placeholder="请输入组件名" style="width: 180px;"></el-input>
        </el-form-item>
        <el-form-item label="是否递归" v-if="data.type === '1'">
          <el-switch v-model="data.leaf"></el-switch>
        </el-form-item>
        <el-form-item label="是否可展示" prop="closeStatus" v-if="data.type === '1'">
          <el-switch v-model="data.showMenu"></el-switch>
        </el-form-item>
        <el-form-item label="是否可关闭" prop="closeStatus" v-if="data.type === '1'">
          <el-switch v-model="data.closeStatus"></el-switch>
        </el-form-item>
        <el-form-item label="路由拓展信息" v-if="data.type === '1'">
          <el-input type="textarea" :rows="2" placeholder="路由拓展信息，动态子路由需要填" v-model="data.meta">
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submit" size="small" icon="el-hg-icon-save" style="margin-left: 40px;">保 存</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
// const
export default {
  name: 'add',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    functionId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      dialogVisible: false,
      rules: {
        code: [
          {
            required: true,
            message: '请输入编号',
            trigger: 'blur'
          },
          {
            pattern: this.$utils.regRule.code,
            message: '编号只能含数字和字母',
            trigger: 'blur'
          }
        ],
        name: [{
          required: true,
          message: '请输入功能名称',
          trigger: 'blur'
        }],
        sort: [
          {
            required: true,
            message: '请输入排序号',
            trigger: 'blur'
          },
          {
            pattern: this.$utils.regRule.nGInteger,
            message: '排序号格式不正确',
            trigger: 'blur'
          }
        ],
        path: [{
          required: true,
          message: '请输入菜单地址',
          trigger: 'blur'
        }],
        routerPath: [{
          required: true,
          message: '请输入路由地址',
          trigger: 'blur'
        }],
        component: [{
          required: true,
          message: '请输入组件地址',
          trigger: 'blur'
        }],
        componentName: [{
          required: true,
          message: '请输入路由名称',
          trigger: 'blur'
        }],
        closeStatus: [{
          required: true,
          message: '请选择是否可关闭',
          trigger: 'change'
        }],
        iconClass: [{
          required: true,
          message: '请选择icon图标',
          trigger: 'change'
        }],
        type: [{
          required: true,
          message: '请选择功能类型',
          trigger: 'change'
        }]
      },
      data: {
        code: '',
        name: '',
        sort: '',
        iconClass: '',
        type: '1',
        path: '',
        closeStatus: false,
        parentId: '',
        updateFlg: 'add',
        routerPath: '',
        componentName: '',
        component: '',
        meta: '',
        showMenu: true
      },
      iconList: []
    };
  },
  mounted() {
    for (let i = 0; i < 26; i++) {
      let item = {
        valueClass: 'icon-img' + (i + 1)
      };
      this.iconList.push(item);
    }
  },
  methods: {
    submit() {
      this.$refs['ruleForm'].validate(valid => {
        if (valid) {
          if (this.data.closeStatus) {
            this.data.closeStatus = '1';
          }
          else {
            this.data.closeStatus = '0';
          }
          this.data.parentId = this.functionId;
          this.saveFunction();
        }
        else {
          console.warn('error submit!!');
          return false;
        }
      });
    },
    async saveFunction() {
      const res = await this.$services.postJson({
        type: 'FUNCTIONMANGEMENT',
        url: 'saveFunction',
        params: JSON.parse(JSON.stringify(this.data))
      });
      if (res.code === '000') {
        this.$toaster.ok('保存成功');
        this.handleClose();
        this.$emit('getAllFunctionList');
      }
      else {
        this.$toaster.error(res.msg);
      }
    },
    handleClose() {
      this.$refs['ruleForm'].resetFields();
      //      this.dialogVisible = false;
      //      this.$emit('close');
    }
  },
  watch: {
    show(val) {
      if (val) {
        this.dialogVisible = true;
        this.data.functionId = this.functionId;
      }
      else {
        this.dialogVisible = false;
      }
    }
  }
};
</script>
<style lang="scss">
@import "@/assets/css/addEditForm.scss";
.myIconStyle {
  width: 20px;
  height: 20px;
  fill: currentColor;
  overflow: hidden;
}
.demo-form-inline {
  .el-form-item {
    height: 28px;
  }
}
</style>
